// Content type registry for managing available content types and their renderers
import { ContentTypeConfig } from './types';

// Registry to hold all content type configurations
const contentTypeRegistry: Record<string, ContentTypeConfig> = {};

// Register a content type
export function registerContentType(config: ContentTypeConfig): void {
  if (contentTypeRegistry[config.id]) {
    console.warn(`Content type with ID "${config.id}" is already registered. Overwriting...`);
  }
  contentTypeRegistry[config.id] = config;
}

// Get a content type by ID
export function getContentType(id: string): ContentTypeConfig | undefined {
  return contentTypeRegistry[id];
}

// Get all registered content types
export function getAllContentTypes(): ContentTypeConfig[] {
  return Object.values(contentTypeRegistry);
}

// Create a default registry export
const registry = {
  registerContentType,
  getContentType,
  getAllContentTypes,
};

export default registry; 